// extracted by mini-css-extract-plugin
export default {"footerIcons":"Footer_footerIcons__32j6F"};